<template>
  <slot />
</template>

<script lang="ts" setup>
import { provideDownloads, useDownloadTasks } from './hooks/tasks';

provideDownloads(useDownloadTasks());
</script>

<style lang="scss" scoped>
</style>
